import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../config');

class ModalView extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			requested_by:"",
			req_by:"",
			requested_to:"",
			req_to:"",
			messenger:"",
			observations:"",
			hour:"",
			date_form:"",
			priority:"",
			unitsSolicited:[],
			unitsAsociation:[],
			user:"",
			user_receive:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(title, id){
		
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_request/'+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res => {
			this.props.waiting.handleClose();
	    	if(res.ok){
	          	return res.json();
	        }else{
	          	res.text().then(function(result) {
	            	swal('¡Error', result, 'error');
	          	});
        	}
        	
        }).then(response => {
			if(response !== undefined){
				var date = new Date(response.date);
				 //obtener usuario
				/*var user = JSON.parse(sessionStorage.getItem('medical_staff'));

				var name = ""
				if (user.names) {name += user.names};
				if (user.lastname1) {name += ' '+user.lastname1};
				if (user.lastname2) {name += ' '+user.lastname2};*/

				this.setState({
					user :  response.user_send,
					requested_by:response.distribuidor,
					requested_to:response.receptor_name,
			      	messenger: response.messenger,
			      	//observations: response.unit_request.observaciones,
			      	hour:response.hour,
			      	date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
			      	priority: response.priority.indexOf('HORAS') !== -1 ? '24 Horas' : 'Urgente',
			      	unitsSolicited:response.detail,
					  //unitsAsociation:response.units_asociation,
					user_receive:response.user_receive,
			      	show: true,
					title: title
			    });

			    this.getHealthFacilities();
			}
		})

		fetch(Config.default.apiGateway.URL+'units_asociation?id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res=>{
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({ 
					unitsAsociation: response
				});
				
			}
		})
	}

	getHealthFacilities(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'health_facilities',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			for (var i = 0; i < response.length; i++) {
				if (response[i].name === this.state.requested_by) {
					this.setState({req_by:response[i].name});

				}else if(response[i].name === this.state.requested_to){
					this.setState({req_to:response[i].name});
				}
			}
		})
	}

	handleClose(){
		this.setState({
			show: false
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.title}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Distribuidor</span>
		        				<input type="text" className="form-control" value={this.state.req_by} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Peticionario</span>
		        				<input type="text" className="form-control" value={this.state.req_to} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Fecha</span>
		        				<input type="date" className="form-control" value={this.state.date_form} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Hora</span>
		        				<input type="text" className="form-control" value={this.state.hour} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Prioridad</span>
		        				<input type="text" className="form-control" value={this.state.priority} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Usuario Solicita</span>
		        				<input type="text" className="form-control" value={this.state.user} disabled/>
		        			</div>
							<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Usuario Recibe</span>
		        				<input type="text" className="form-control" value={this.state.user_receive} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Mensajero</span>
		        				<input type="text" className="form-control" value={this.state.messenger || ""} disabled/>
		        			</div>

		        			{/*<div className="col-xs-12">
		        				<span className="span-min">Observaciones</span>
		        				<textarea className="form-control" value={this.state.observations} disabled></textarea>
		        			</div>*/}
		        		</div>
		        		<div className="col-xs-12">
		        			<fieldset>
			        			<legend>Unidades Solicitadas</legend>
			        			<Table responsive hover>
			        				<thead>
					                  	<tr>
						                    <th>Componente Sanguineo</th>
						                    <th>Cantidad</th>
						                    <th>Grupo y RH</th>
						                    <th>Observaciones</th>
					                  	</tr>
					                </thead>
					                <tbody>
					                 	{this.state.unitsSolicited.map( (unit, index) => (
					                    	<tr key={index}>
					                      		<td>{unit.component}</td>
						                      	<td>{unit.amount}</td>
						                      	<td>
						                      		{unit.group+
						                      		(unit.rh === 'POSITIVO' ? '+' : unit.rh === 'NEGATIVO' ? '-' : unit.rh)} 
						                      	</td>
						                      	<td>{unit.observations}</td>
					                    	</tr>
					                  	))}
					                </tbody>
			        			</Table>
			        		</fieldset>

			        		{this.state.unitsAsociation.length > 0 ?
			        			<fieldset>
				        			<legend>
				        				{this.state.req_to === sessionStorage.getItem('health_facilities_name') ?
				        					'Unidades Recibidas'
				        				: 'Unidades Enviadas'}
				        			</legend>
				        			<Table responsive hover>
				        				<thead>
						                  	<tr>
						                  		<th>No. Unidad</th>
							                    <th>Componente Sanguíneo</th>
							                    <th>No. Componente</th>
							                    <th>Caducidad</th>
							                    <th>Volumen</th>
						                  	</tr>
						                </thead>
						                <tbody>
						                	{this.state.unitsAsociation.map((u, i)=>{
						                		console.log(u)
						                		return <tr key={i}>
						                			<td>{u.unit.unit_number}</td>
							                      	<td>{u.blood_component.component}</td>
							                      	<td>{u.unit.component_number}</td>
							                      	<td>{moment(u.unit.caducidad).format('DD/MM/YYYY')} </td>
							                      	<td>{u.unit.volume} ml</td>
						                		</tr>
						                	})}
						                </tbody>
				        			</Table>
				        		</fieldset>
			        		: null}
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalView);